/**
 * IPD Partner Countries reference data grouped by continent
 */

export type Continent = 'Africa' | 'Asia' | 'Europe' | 'South America';

export interface CountryOption {
  code: string;
  name: string;
  continent: Continent;
}

export const CONTINENTS: Continent[] = ['Africa', 'Asia', 'Europe', 'South America'];

export const IPD_COUNTRIES: CountryOption[] = [
  { code: 'CI', name: "Côte d'Ivoire", continent: 'Africa' },
  { code: 'EG', name: 'Egypt', continent: 'Africa' },
  { code: 'ET', name: 'Ethiopia', continent: 'Africa' },
  { code: 'GH', name: 'Ghana', continent: 'Africa' },
  { code: 'KE', name: 'Kenya', continent: 'Africa' },
  { code: 'MG', name: 'Madagascar', continent: 'Africa' },
  { code: 'MA', name: 'Morocco', continent: 'Africa' },
  { code: 'SN', name: 'Senegal', continent: 'Africa' },
  { code: 'ZA', name: 'South Africa', continent: 'Africa' },
  { code: 'TZ', name: 'Tanzania', continent: 'Africa' },
  { code: 'TN', name: 'Tunisia', continent: 'Africa' },
  { code: 'KH', name: 'Cambodia', continent: 'Asia' },
  { code: 'ID', name: 'Indonesia', continent: 'Asia' },
  { code: 'NP', name: 'Nepal', continent: 'Asia' },
  { code: 'LK', name: 'Sri Lanka', continent: 'Asia' },
  { code: 'UZ', name: 'Uzbekistan', continent: 'Asia' },
  { code: 'UA', name: 'Ukraine', continent: 'Europe' },
  { code: 'BR', name: 'Brazil', continent: 'South America' },
  { code: 'CO', name: 'Colombia', continent: 'South America' },
  { code: 'EC', name: 'Ecuador', continent: 'South America' },
  { code: 'PE', name: 'Peru', continent: 'South America' },
];

const SUPPORTED_COUNTRY_NAMES = new Set(IPD_COUNTRIES.map((c) => c.name));

/**
 * Group countries by continent
 */
export function groupCountriesByContinent(
  countries: CountryOption[] = IPD_COUNTRIES
): Record<Continent, CountryOption[]> {
  const result = {} as Record<Continent, CountryOption[]>;
  for (const continent of CONTINENTS) {
    result[continent] = countries.filter((c) => c.continent === continent);
  }
  return result;
}

/**
 * Check if a country name is in the supported IPD partner list
 */
export function isSupportedCountryName(name: string): boolean {
  return SUPPORTED_COUNTRY_NAMES.has(name);
}
